import format from 'date-fns/format';
import { CalendarView } from './calendarView';

const MonthParameter = 'month';
const WeekParameter = 'week';
const OnlyOwnParameter = 'own';
const BrokerParameter = 'broker';

export type CalendarLocation = {
    view: CalendarView;
    date: Date | undefined;
    onlyOwn: boolean;
    brokerId: number | null;
};

export type CalendarFilters = {
    onlyOwn: boolean;
    brokerId: number | null;
};

function brokerIdFrom(params: URLSearchParams): number | null {
    let broker = Number(params.get(BrokerParameter));
    return Number.isInteger(broker) && broker > 0 ? broker : null;
}

export function calendarLocationFromSearch(search: string): CalendarLocation {
    let params = new URLSearchParams(search);
    let onlyOwn = params.get(OnlyOwnParameter) === '1';
    let brokerId = brokerIdFrom(params);
    let week = params.get(WeekParameter);
    if (week && /^\d{4}-\d{2}-\d{2}$/.test(week)) {
        let [year, month, day] = week.split('-').map(Number);
        return { view: 'week', date: new Date(year, month - 1, day), onlyOwn, brokerId };
    }
    let month = params.get(MonthParameter);
    if (month && /^\d{4}-\d{2}$/.test(month)) {
        let [year, monthNumber] = month.split('-').map(Number);
        return { view: 'month', date: new Date(year, monthNumber - 1, 1), onlyOwn, brokerId };
    }
    return { view: 'month', date: undefined, onlyOwn, brokerId };
}

export function searchForCalendarLocation(
    view: CalendarView,
    date: Date,
    filters: CalendarFilters
): string {
    let search =
        view === 'week'
            ? `?${WeekParameter}=${format(date, 'yyyy-MM-dd')}`
            : `?${MonthParameter}=${format(date, 'yyyy-MM')}`;
    if (filters.brokerId !== null) {
        search += `&${BrokerParameter}=${filters.brokerId}`;
    }
    if (filters.onlyOwn) {
        search += `&${OnlyOwnParameter}=1`;
    }
    return search;
}
